/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Dashboard_Billing_Billed_OnInputs */



/**
* | output |
* | --- |
* | "Billed {date}" |
*
* @param {Dashboard_Billing_Billed_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_billed_on = /** @type {((inputs: Dashboard_Billing_Billed_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Billed_OnInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Abgerechnet am ${i?.date}`)
	return /** @type {LocalizedString} */ (`Billed ${i?.date}`)
});